(() => {
  const openGlobalSwitcher = () => {
    const trigger = document.querySelector('.ec-switcher__trigger');
    if (trigger) trigger.click();
  };

  const ensureFab = (root) => {
    if (window.innerWidth <= 620) return;
    let fab = root.querySelector('.ec-home__ecosystems-fab');
    if (!fab) {
      fab = document.createElement('button');
      fab.type = 'button';
      fab.className = 'ec-home__ecosystems-fab';
      fab.setAttribute('aria-label', 'Apri tutti gli ecosistemi ECCOMI');
      fab.innerHTML = [
        '<span class="ec-home__ecosystems-fab-mark" aria-hidden="true">e</span>',
        '<span class="ec-home__ecosystems-fab-copy"><strong>Ecosistemi</strong><small>Scopri tutti i servizi</small></span>',
        '<span class="ec-home__ecosystems-fab-arrow" aria-hidden="true">›</span>'
      ].join('');
      root.appendChild(fab);
    }
    if (!fab.dataset.ecBound) {
      fab.dataset.ecBound = '1';
      fab.addEventListener('click', openGlobalSwitcher);
    }
  };

  const setup = () => {
    if (window.innerWidth <= 620) return;
    document.querySelectorAll('.template-index .ec-desktop-master').forEach((el) => {
      el.style.setProperty('display', 'none', 'important');
    });
    document.querySelectorAll('[data-ec-home]').forEach(ensureFab);
  };

  document.addEventListener('DOMContentLoaded', setup);
  document.addEventListener('shopify:section:load', setup);
  window.addEventListener('pageshow', setup);
})();
